// @flow

function checkTelephone(value? : string) : boolean {
    return value.match(/^0\d{2,3}-\d{4,8}$/)
}

export default checkTelephone;